import { render } from "./MobilePreviewModal.vue?vue&type=template&id=5efc3874&scoped=true&ts=true"
import script from "./MobilePreviewModal.vue?vue&type=script&lang=ts"
export * from "./MobilePreviewModal.vue?vue&type=script&lang=ts"

import "./MobilePreviewModal.vue?vue&type=style&index=0&id=5efc3874&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efc3874"]])

export default __exports__